import { Container } from "@mui/material";

import { ComponentHeader } from "../ui";
import { HomeServicesGrid } from "@/components/ui";
import { services } from "@/constants";
import { PAGE_COPY } from "@/constants/pages";

export const HomeServices = () => {
  return (
    <Container maxWidth="lg">
      <ComponentHeader
        title={PAGE_COPY.sections.homeServices.title}
        subTitle={PAGE_COPY.sections.homeServices.subTitle}
        component="h2"
      />
      <HomeServicesGrid items={services} />
    </Container>
  );
};
